// extracted by mini-css-extract-plugin
module.exports = {"w11fipa1":"w11fipa1"};